export default {"src":"/_next/static/media/ra-outline-air-freight.f34a4194.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};